import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as ticketActions from './../../../../../actions/ticketAction';
import * as userAction from './../../../../../actions/userAction';
import TicketDetail from './TicketDetail';

const mapStateToProps = state => {
    return {
        ticketState: state.ticketReducer,
        userState: state.userReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTicketDetail: (id) => dispatch(ticketActions.getTicketDetail(id)),
        setTicketDetail: (ticket) => dispatch(ticketActions.setTicketDetail(ticket)),
        updateTicket: (ticket) => dispatch(ticketActions.updateTicket(ticket)),

        getMyTicketDetail: (id) => dispatch(ticketActions.getMyTicketDetail(id)),
        setMyTicketDetail: (ticket) => dispatch(ticketActions.setMyTicketDetail(ticket)),
        updateMyTicket: (ticket) => dispatch(ticketActions.updateMyTicket(ticket)),
        
        getCSUsers: (params) => dispatch(userAction.getCSUserAction(params)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TicketDetail));
